var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import { isDate, hideWhenDisplaying, isIcon, disguised, isTime, isCheckbox, hideWhenCreatingAndEditing, isCode, } from 'src/types/columnFlags';
import getLeafsFromListThatLooksLikeTree from '../../utils/getLeafsFromListThatLooksLikeTree';
import ClassMetricRenderer from './components/ClassMetricRenderer.vue';
import ApiLog from './components/ApiLog.vue';
import rpc from 'src/api/rpc';
import fullScreenLoading from 'src/utils/fullScreenLoading';
import GenericTableWrappedInDialog from 'src/components/GenericTable/GenericTableWrappedInDialog.vue';
import Notify from 'quasar/src/plugins/Notify.js';;
import getSessionContext from 'src/utils/context/getSessionContext';
import openMainLookupDialog from 'src/utils/dialogs/openMainLookupDialog';
import getFullTable from 'src/utils/entityOperations/getFullTable';
import createRecords from 'src/utils/entityOperations/createRecords';
import setCurrentModeAsGenericTable from 'src/utils/currentMode/setCurrentModeAsGenericTable';
import { row_menu } from 'src/utils/entityOperations/columns/basicColumns';
import refreshSpecifiedRecordsIfExist from 'src/utils/entityOperations/refreshSpecifiedRecordsIfExist';
const controlledActions = {
    create: [-1],
    fetch: [116],
    update: [-1],
    delete: [-1],
    downloadList: [116],
    uploadList: [-1],
};
const nonDataColumnNames = ['row_menu'];
const columns = () => {
    const rowMenuItems = [
        {
            name: 'calculate_class',
            label: 'Calculate class now',
            icon: 'mdi-math-compass',
            clickHandler: (props) => __awaiter(void 0, void 0, void 0, function* () {
                fullScreenLoading.show();
                yield rpc('ci.calculate_class_api', { class_id: props.row.id });
                refreshSpecifiedRecordsIfExist('ci.classes', [props.row.id]);
                fullScreenLoading.hide();
            }),
        },
        {
            name: 'treat_class_as_member_of_time_aggregate',
            label: 'Asign this time slot to a specific time of week aggregate',
            tooltipContent: "This will associate this class to a specific time of week aggregate (e.g., Weekend Peak), regardless of the class' date and time.",
            icon: 'mdi-clock-time-eight-outline',
            clickHandler: (cellProps) => __awaiter(void 0, void 0, void 0, function* () {
                openMainLookupDialog({
                    dataParam: getFullTable('calendars.times_of_week_aggregates'),
                    singleSelectProp: true,
                    handleSelectorValueSelection: (selectedValue) => __awaiter(void 0, void 0, void 0, function* () {
                        const classObj = cellProps.row;
                        const record = {
                            assigned_time_of_week_aggregate_id: Number(selectedValue),
                            scope_org_id: classObj.location_id,
                            //
                            scope_on_monday: classObj.day_of_week_text === 'Monday',
                            scope_on_tuesday: classObj.day_of_week_text === 'Tuesday',
                            scope_on_wednesday: classObj.day_of_week_text === 'Wednesday',
                            scope_on_thursday: classObj.day_of_week_text === 'Thursday',
                            scope_on_friday: classObj.day_of_week_text === 'Friday',
                            scope_on_saturday: classObj.day_of_week_text === 'Saturday',
                            scope_on_sunday: classObj.day_of_week_text === 'Sunday',
                            //
                            scope_start_time: classObj.start_time,
                            scope_end_time: classObj.start_time, // yes, start_time not end_time
                        };
                        const response = yield createRecords('calendars.towa_overrides', [
                            record,
                        ]);
                        if (response) {
                            if (response.result === 'error') {
                                Notify.create({ type: 'negative', message: 'Error' });
                            }
                            if (response.result === 'success') {
                                Notify.create({
                                    icon: 'mdi-check',
                                    type: 'positive',
                                    message: 'Success',
                                    timeout: 5000,
                                    progress: true,
                                    actions: [
                                        { label: 'Ok', color: 'white' },
                                        {
                                            label: 'See created record',
                                            color: 'white',
                                            handler: () => setCurrentModeAsGenericTable({
                                                localEntityNameProp: 'calendars.towa_overrides',
                                                startingSortingModelProp: [
                                                    { field: 'id', direction: 'desc' },
                                                ],
                                            }),
                                        },
                                    ],
                                });
                            }
                        }
                    }),
                });
            }),
        },
        {
            name: 'reservations_list',
            label: 'Reservations',
            icon: 'mdi-account-details-outline',
            clickHandler: (cellProps, ctx) => {
                const tableProps = {
                    localEntityNameProp: 'ci.reservations',
                    startingFilterModelProp: [
                        { field: 'class_id', predicate: 'equals', value: cellProps.row.id },
                    ],
                    fetchIntoLocalDataInsteadOfStore: true,
                    startingSortingModelProp: [],
                    initialRowsPerPageProp: 100,
                };
                ctx.openDialog(GenericTableWrappedInDialog, {
                    tableProps,
                    qDialogProps: {
                        maximized: true,
                    },
                });
            },
        },
        {
            name: 'api_log',
            needOneOfControlledActions: [312],
            label: 'See API log',
            icon: 'mdi-swap-horizontal',
            clickHandler: (props, ctx) => {
                ctx.dialogComponentPlaceHolder = ApiLog;
                ctx.dialogComponentPlaceHolderProps = { classObj: props.row };
            },
        },
    ];
    const commonMetricProps = {
        isNumeric: true,
        isInteger: true,
        hideWhenCreating: true,
        component: ClassMetricRenderer,
        componentProps: (col, row, ctx) => ({ row, col, ctx }),
        uiFilterTypes: ['numberFilters'],
    };
    const commonMetricPropsWithoutHistoryComponent = {
        isNumeric: true,
        isInteger: true,
        hideWhenCreating: true,
        uiFilterTypes: ['numberFilters'],
    };
    const commonMetricForAnotherClassProp = {
        isNumeric: true,
        isInteger: true,
        hideWhenCreating: true,
        component: ClassMetricRenderer,
        componentProps: (col, row, ctx) => ({
            row,
            col,
            ctx,
            fieldIsClassIdProp: true,
        }),
        tooltipContent: "Click to navigate to the class's record",
    };
    const overbookedConditionalFormatting = {
        conditionalClasses: (row) => {
            if ((row.bookings_minus_cancels_total || 0) > (row.capacity || 0)) {
                return ['highlighted-value-box', 'bg-red-10', 'text-white'];
            }
            if (row.bookings_minus_cancels_total === row.capacity) {
                return ['highlighted-value-box', 'bg-deep-orange-5', 'text-white'];
            }
        },
    };
    const cols = [
        row_menu({ rowMenuItems: rowMenuItems }),
        {
            name: 'id',
            disguised,
            style: 'width:80px',
            uiFilterTypes: ['selectedValuesFilter', 'numberFilters'],
        },
        {
            name: 'native_id',
            transformToHtml: ({ row, col }) => getSessionContext().tenant_id === 422
                ? `<a target="_blank" href="https://barrysbootcamp.marianatek.com/admin/schedule/classes/edit/${row[col.field]}">${row[col.field]}</a>`
                : undefined,
            disguised: disguised,
            style: 'width:80px',
            thStyles: 'white-space:nowrap',
            label: 'Native ID',
            tooltipContent: (cellProps) => String(cellProps.row.native_id),
            uiFilterTypes: ['selectedValuesFilter', 'numberFilters'],
        },
        {
            name: 'location_id',
            disguised,
            cellDivClasses: 'max-lines-1',
            style: 'width:200px;white-space:nowrap',
            align: 'left',
            references: getLeafsFromListThatLooksLikeTree(getFullTable('orgs.orgs').filter((org) => ![885, 886].includes(org.id))),
        },
        // { name: 'class_type_id', disguised, cellDivClasses: 'max-lines-2', style: 'width:200px', label: 'Class type', field: 'class_type_id', align: 'left', references: getLeafsFromListThatLooksLikeTree(rootState['products.products'].list) },
        {
            name: 'product_name',
            disguised,
            cellDivClasses: 'max-lines-1',
            style: 'width:200px;white-space:nowrap',
            label: 'Class type',
            align: 'left',
            uiFilterTypes: ['textFilters', 'selectedValuesFilter'],
        },
        {
            name: 'start_date',
            columnGroup: 'Class start',
            label: 'Date',
            isDate,
            uiFilterTypes: ['selectedValuesFilter'],
        },
        {
            name: 'day_of_week_text',
            columnGroup: 'Class start',
            label: 'Week day',
            uiFilterTypes: ['selectedValuesFilter'],
        },
        {
            name: 'start_time',
            columnGroup: 'Class start',
            label: 'Time',
            isTime,
            uiFilterTypes: ['selectedValuesFilter'],
        },
        { name: 'instructors', label: 'Instructor(s)', hideWhenDisplaying },
        {
            name: 'is_public',
            label: '',
            labelInColumnSelector: 'Private class indicator',
            tooltipContentIsHTML: true,
            tooltipContent: ({ row }) => !row.is_public
                ? '<p>Private class</p><ul><li>Click to show only private classes</li><li>Right-click to show only public classes</li></ul>'
                : '',
            isIcon,
            icon: ({ row }) => !row.is_public ? 'mdi-lock-check-outline' : '',
            align: 'center',
            cellClickHandler: (cellProps, ctx) => ctx.injectIntoLocalFilterModel([
                { field: 'is_public', predicate: 'isNotTrue' },
            ]),
            cellRightClickHandler: (cellProps, ctx) => ctx.injectIntoLocalFilterModel([
                { field: 'is_public', predicate: 'isTrue' },
            ]),
        },
        Object.assign(Object.assign({ name: 'expected_checked_in_all_bookings', hideForTenandIds: [895], hideWhenDisplaying, label: 'Expected checked-in total bookings' }, commonMetricProps), { componentProps: (col, row, ctx) => ({
                col,
                row,
                ctx,
                class_metric_ids_prop: [4, 13],
            }) }),
        Object.assign({ name: 'expected_checked_in_all_bookings_right_tail', hideForTenandIds: [895], hideWhenDisplaying, label: 'Expected checked-in total bookings, aggressive' }, commonMetricProps),
        Object.assign({ name: 'expected_checked_in_organic_bookings', hideWhenDisplaying, label: 'Expected checked-in organic bookings' }, commonMetricProps),
        Object.assign({ name: 'expected_checked_in_organic_bookings_right_tail', hideForTenandIds: [895], hideWhenDisplaying, label: 'Expected checked-in organic bookings, aggressive' }, commonMetricProps),
        Object.assign({ name: 'expected_checked_in_broker_bookings', hideForTenandIds: [895], hideWhenDisplaying, label: 'Expected checked-in broker bookings' }, commonMetricProps),
        Object.assign({ name: 'broker_availability_engine_recommendation', columnGroup: 'Broker availalability and price', hideWhenDisplaying, label: 'Broker availability cap engine recommendation' }, commonMetricProps),
        Object.assign({ name: 'broker_availability_per_rules', columnGroup: 'Broker availalability and price', hideWhenDisplaying, label: 'Broker availability cap, with rules applied' }, commonMetricProps),
        Object.assign({ name: 'broker_availability_per_rules__classpass', columnGroup: 'Broker availalability by broker', label: 'Broker availability cap, with rules applied : Classpass' }, commonMetricProps),
        Object.assign({ name: 'broker_availability_per_rules__fitreserve', columnGroup: 'Broker availalability by broker', label: 'Broker availability cap, with rules applied : Fitreserve' }, commonMetricProps),
        Object.assign({ name: 'broker_availability_per_rules__gympass', columnGroup: 'Broker availalability by broker', label: 'Broker availability cap, with rules applied : Gympass' }, commonMetricProps),
        Object.assign({ name: 'broker_availability_per_rules__max', columnGroup: 'Broker availalability by broker', label: 'Broker availability cap, with rules applied : Max' }, commonMetricProps),
        Object.assign(Object.assign({ name: 'broker_availability_per_rules_and_overrides', columnGroup: 'Broker availalability and price', hideWhenDisplaying, headerInfoTip: 'Broker availability cap, with rules and overrides applied', label: 'Broker availability cap' }, commonMetricProps), { componentProps: (col, row, ctx) => ({
                col,
                row,
                ctx,
                class_metric_ids_prop: [36, 9, 7],
            }) }),
        Object.assign(Object.assign({ name: 'broker_availability_remaining_spots', columnGroup: 'Broker availalability and price', labelColorMap: {
                default: 'var(--theme-green-40)',
                '0': 'var(--theme-orange-40)',
                '': 'var(--theme-orange-40)',
                null: 'var(--theme-orange-40)',
                undefined: 'var(--theme-orange-40)',
            }, headerInfoTip: 'Broker availability, remaining spots', label: 'Remaining broker availability' }, commonMetricProps), { componentProps: (col, row, ctx) => ({
                col,
                row,
                ctx,
                class_metric_ids_prop: [36, 23, 9, 15, 7],
            }) }),
        Object.assign(Object.assign({ name: 'capacity', label: 'Capacity' }, commonMetricProps), overbookedConditionalFormatting),
        Object.assign(Object.assign({ name: 'bookings_minus_cancels_total', headerInfoTip: 'Bookings minus cancels and noshows, total', label: 'Active bookings' }, commonMetricProps), overbookedConditionalFormatting),
        Object.assign({ name: 'bookings_minus_cancels_organic', hideWhenDisplaying, headerInfoTip: 'Bookings minus cancels and noshows, organic', label: 'Active bookings, organic' }, commonMetricProps),
        Object.assign({ name: 'bookings_minus_cancels_broker', columnGroup: 'Broker availalability and price', hideWhenDisplaying, headerInfoTip: 'Bookings minus cancels and noshows, broker', label: 'Active bookings, broker' }, commonMetricProps),
        Object.assign({ name: 'cumulative_cancels_and_noshows_total', hideWhenDisplaying, label: 'Cumulative cancels and noshows, total' }, commonMetricProps),
        Object.assign({ name: 'cumulative_cancels_and_noshows_organic', hideWhenDisplaying, label: 'Cumulative cancels and noshows, organic' }, commonMetricProps),
        Object.assign({ name: 'cumulative_cancels_and_noshows_broker', hideWhenDisplaying, label: 'Cumulative cancels and noshows, broker' }, commonMetricProps),
        Object.assign({ name: 'expected_final_late_cancels_and_noshows_alpha_5', hideForTenandIds: [895], hideWhenDisplaying, label: 'Expected final late cancels and noshows, 𝛼=0.05' }, commonMetricProps),
        Object.assign({ name: 'expected_final_late_cancels_and_noshows_alpha_10', hideForTenandIds: [895], hideWhenDisplaying, label: 'Expected final late cancels and noshows, 𝛼=0.10' }, commonMetricProps),
        Object.assign({ name: 'expected_final_late_cancels_and_noshows_alpha_15', hideForTenandIds: [895], hideWhenDisplaying, label: 'Expected final late cancels and noshows, 𝛼=0.15' }, commonMetricProps),
        Object.assign({ name: 'expected_final_late_cancels_and_noshows_alpha_20', hideForTenandIds: [895], hideWhenDisplaying, label: 'Expected final late cancels and noshows, 𝛼=0.20' }, commonMetricProps),
        Object.assign({ name: 'expected_final_late_cancels_and_noshows_alpha_25', hideForTenandIds: [895], hideWhenDisplaying, label: 'Expected final late cancels and noshows, 𝛼=0.25' }, commonMetricProps),
        Object.assign(Object.assign({ name: 'expected_final_late_cancels_and_noshows_alpha_50', hideForTenandIds: [895], hideWhenDisplaying, label: 'Expected final late cancels and noshows, 𝛼=0.50' }, commonMetricProps), { columnGroup: 'standby-management' }),
        Object.assign({ name: 'cml_late_cancels_and_noshows', hideForTenandIds: [895], hideWhenDisplaying, columnGroup: 'standby-management', label: 'Late cancels and noshows' }, commonMetricProps),
        Object.assign(Object.assign({ name: 'standby_capacity', hideForTenandIds: [895], columnGroup: 'standby-management' }, commonMetricProps), { componentProps: (col, row, ctx) => ({
                col,
                row,
                ctx,
                class_metric_ids_prop: [29, 37, 34],
            }), labelColorMap: {
                '0': 'var(--theme-grey-40)',
                '': 'var(--theme-grey-40)',
                null: 'var(--theme-grey-40)',
                undefined: 'var(--theme-grey-40)',
            } }),
        Object.assign({ name: 'converted_standby_count', hideForTenandIds: [895], hideWhenDisplaying, columnGroup: 'standby-management' }, commonMetricPropsWithoutHistoryComponent),
        Object.assign({ name: 'closest_class_7_days_ago', columnGroup: 'past-similar-classes', headerInfoTip: "Class that is most similar (same location and closest start time) to the records's class, exactly 7 days before that class", label: 'Closest class 7 days ago' }, commonMetricForAnotherClassProp),
        Object.assign({ name: 'closest_class_14_days_ago', columnGroup: 'past-similar-classes', headerInfoTip: "Class that is most similar (same location and closest start time) to the records's class, exactly 14 days before that class", label: 'Closest class 14 days ago' }, commonMetricForAnotherClassProp),
        {
            name: 'automatic_inventory_and_pricing_management_disabled',
            isCheckbox,
            hideWhenDisplaying,
        },
        {
            name: 'automatic_class_standby_capacity_management_is_disabled',
            isCheckbox,
            hideWhenDisplaying,
        },
        { name: 'is_at_home_studio', isCheckbox, hideWhenDisplaying },
        {
            name: 'instructor_scheduling_app_automation_is_disabled',
            isCheckbox,
            hideWhenDisplaying,
        },
        { name: 'is_within_booking_window', isCheckbox, hideWhenDisplaying },
        {
            name: 'overrides',
            isCode,
            codeLanguage: 'JSON',
            hideWhenDisplaying,
            hideWhenCreatingAndEditing,
        },
        {
            name: 'tags',
            isCode,
            codeLanguage: 'JSON',
            hideWhenDisplaying,
            hideWhenCreatingAndEditing,
        },
    ];
    return cols;
};
const localEntity = constructLocalEntity({
    columns,
    remoteEntityName: 'ci.classes',
    apiVersion: 1,
    controlledActions,
    pageTitle: 'Classes',
});
export default localEntity;
